import { requestNotifications } from "hiringagent-dashboard/actions/notifications";
import { notificationsSliceSelector } from "hiringagent-dashboard/selectors";
import { createConnector } from "common/connectors/utils";

export default createConnector(
  "WithNotifications",
  notificationsSliceSelector,
  { onLoad: requestNotifications },
);
